import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'aig-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss'],
  standalone: true
})
export class HeroComponent implements OnInit {
  @Input() info!: {
    image: string;
    alt: string
  }
  constructor() { }

  ngOnInit() {
  }

}
